import React, { useState } from "react";
import Button from "./Button";
import Card from "./Card";
import InputField from "./InputField";
import "./Popup.css";
import { sendFeedbackToAwsLambda } from "../utils/NetworkUtils";


function ReportIssuePopup({ onCancelClick, callBack }) {
  const [disabled, setDisabled] = useState(true);
  const [description, setDescription] = useState("");

  function onDescriptionChanged(description) {
    setDescription(description);
    if (description !== "") {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }

  function onSendFeedbackClick() {
    sendFeedbackToAwsLambda(description, callBack);
  }

  return (
    <div className="container">
      <Card margined>
        <div className="title">Report an issue</div>
        <div className="description">Do not send any personal or sensitive information</div>
        <div>
          <InputField hint="Issue (Required)" big onChange={(event) => onDescriptionChanged(event.target.value)} />
          <div className="description">Enter a brief description of the issue</div>
        </div>
        <div className="buttons">
          <Button text="Cancel" btnStyle="alt1" onClick={onCancelClick} />
          <Button text="Send" disabled={disabled} onClick={onSendFeedbackClick} />
        </div>
      </Card>
    </div>
  );
}

export default React.memo(ReportIssuePopup);
